/* index.js */

"use strict";

module.exports = {
    Resize: {
        ElementResizeDetectionUtility: require("./Resize/ElementResizeDetectionUtility"),
    },
    Scroll: {
        ScrollbarSizeDetectionUtility: require("./Scroll/ScrollbarSizeDetectionUtility"),
    },
    Style: {
        DynamicStylesheetUtility: require("./Style/DynamicStylesheetUtility"),
    },
    escapeHtml: require("./EscapeHtml"),
};
